import { render, staticRenderFns } from "./LoadingAnimationWithoutBg.vue?vue&type=template&id=46f47b6c&"
import script from "./LoadingAnimationWithoutBg.vue?vue&type=script&lang=ts&"
export * from "./LoadingAnimationWithoutBg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports